/**
 * pss/dropdowns — Interactivity API store for navigation-picker
 * dropdowns on procedure and doctor archive pages. Each <select>
 * option's `value` is the destination URL; on change we navigate the
 * browser there. Pure nav: no in-page filtering, no URL-param munging.
 *
 * Cross-dimension narrowing (e.g. "Dr. Smith's breast augmentations")
 * is deliberately out of scope here and is the territory of the
 * forthcoming frontend-filters add-on.
 */

import { store } from '@wordpress/interactivity';

store('pss/dropdowns', {
    actions: {
        navigate(event: Event) {
            const target = event.currentTarget;
            if (!(target instanceof HTMLSelectElement)) return;
            const href = target.value;
            // Empty value === the disabled "Select …" placeholder; ignore.
            if (typeof href !== 'string' || href === '') return;
            window.location.assign(href);
        },
    },
});
